import { fontList } from '../../core/font-list';
import { colorListPairs } from '../../core/color-list';

export let params = {
  'category': 'animation',
  'parameters': {
    'size': {
      'default': {
        'key': '600 x 600',
        'value': [600, 600],
        'label': '600 x 600'
      },
      'label': 'Afmeting',
      'type': 'array',
      'values': [
        {
          'key': '1500 x 1500',
          'value': [1500, 1500],
          'label': '1500 x 1500'
        },
        {
          'key': '1200 x 1200',
          'value': [1200, 1200],
          'label': '1200 x 1200'
        },
        {
          'key': '900 x 900',
          'value': [900, 900],
          'label': '900 x 900'
        },
        {
          'key': '600 x 600',
          'value': [600, 600],
          'label': '600 x 600'
        },
        {
          'key': '400 x 400',
          'value': [400, 400],
          'label': '400 x 400'
        },
        {
          'key': '300 x 300',
          'value': [300, 300],
          'label': '300 x 300'
        },
      ],
      'control': 'standard-select',
      'description': 'Afmeting van de visualisatie',
    },
    'width': {
      'default': 600,
      'label': 'Breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'height': {
      'default': 600,
      'label': 'Hoogte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'text': {
      'default': 'Lorem ipsum\r\n\r\nNext line\nWhat line is this',
      'label': 'Tekst',
      'type': 'string',
      'control': 'standard-textarea',
    },
    'textFontSize': {
      'default': 24,
      'label': 'Font grootte tekst',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'textLineHeight': {
      'default': 1.3,
      'label': 'Regelhoogte tekst',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'textFontColor': {
      'default': '#FFFFFF',
      'label': 'Font kleur tekst',
      'type': 'string',
      'control': 'standard-control',
    },
    'colorScheme': {
      'default': colorListPairs[1],
      'control': 'cbs-color-scheme',
    },
    'marginLeft': {
      'default': 20,
      'label': 'Linkermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginRight': {
      'default': 40,
      'label': 'Rechtermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginTop': {
      'default': 40,
      'label': 'Bovenmarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginBottom': {
      'default': 80,
      'label': 'Ondermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'cbsLogoY': {
      'default': 60,
      'label': 'Logo Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'cbsLogoWidth': {
      'default': 240,
      'label': 'Breedte CBS logo',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'cbsLogoColor': {
      'default': '#00B3D5',
      'label': 'Kleur logo',
      'type': 'string',
      'control': 'standard-number',
    },
    'cbsPayoffY': {
      'default': 500,
      'label': 'Payoff Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'cbsPayoffFontSize': {
      'default': 42,
      'label': 'Font grootte payoff',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'cbsPayoffFontColor': {
      'default': '#0058b8',
      'label': 'Kleur payoff',
      'type': 'string',
      'control': 'standard-number',
    },
    'statbelLogoWidth': {
      'default': 460,
      'label': 'Breedte Statbel logo',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'statbelLogoY': {
      'default': 248,
      'label': 'Payoff Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'tilastokeskusLogoWidth': {
      'default': 300,
      'label': 'Breedte Tilastokeskus logo',
      'type': 'numeric',
      'control': 'standard-number',
    },
    // 'tilastokeskusLogoHeight': {
    //   'default': 600,
    //   'label': 'Hoogte Tilastokeskus logo',
    //   'type': 'numeric',
    //   'control': 'standard-number',
    // },
    'tilastokeskusLogoY': {
      'default': 0,
      'label': 'Logo Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'tilastokeskusLogoColor': {
      'default': '#999999',
      'label': 'Kleur logo',
      'type': 'string',
      'control': 'standard-number',
    },
    'tilastokeskusTextWidth': {
      'default': 300,
      'label': 'Breedte Tilastokeskus text',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'tilastokeskusTextX': {
      'default': 120,
      'label': 'Logo text X',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'tilastokeskusTextY': {
      'default': 20,
      'label': 'Logo text Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'scbLogoY': {
      'default': 0,
      'label': 'Logo Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'scbLogoLetterColor': {
      'default': '#FFFFFF',
      'label': 'Kleur logo',
      'type': 'string',
      'control': 'standard-number',
    },
    'scbTextWidth': {
      'default': 300,
      'label': 'Breedte SCB text',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'destatisLogoY': {
      'default': 60,
      'label': 'Logo Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'destatisLogoWidth': {
      'default': 240,
      'label': 'Breedte Destatis logo',
      'type': 'numeric',
      'control': 'standard-number',
    },
  },
  'timings': {
    'logoTilastoKeskusAnimation': {
      'default': 1,
      'label': 'Logo Tilastokeskus animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseText': {
      'default': 3,
      'label': 'Pause met text',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'slide1Animation': {
      'default': 1,
      'label': 'Slide 1 animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'slide2Animation': {
      'default': 1,
      'label': 'Slide 2 animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'logoCBSAnimation': {
      'default': 1,
      'label': 'Logo CBS animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'payoffCBSAnimation': {
      'default': 1,
      'label': 'Payoff CBS animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseCBS': {
      'default': 1,
      'label': 'Pause met logo CBS',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'logoStatbelAnimation': {
      'default': 2,
      'label': 'Logo Statbel animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseStatbel': {
      'default': 1,
      'label': 'Pause met logo Statbel',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseEnd': {
      'default': 2,
      'label': 'Pause aan het einde',
      'type': 'numeric',
      'control': 'standard-number'
    }
  },
  'parameterGroups': [
    {
      'title': 'Primair',
      'collapsed': false,
      'keys': ['size','colorScheme', 'text'],
    },
    // {
    //   'title': 'Secundair',
    //   'collapsed': true,
    //   'keys': ['circleSize','circleColorScheme'],
    // }
  ],
  'timingGroups': [
    {
      'title': 'Timing',
      'collapsed': true,
      'keys': ['logoCBSAnimation', 'payoffCBSAnimation']
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/animations/test/social.params.ts